<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Регион"
    no-data-text="Регион не найден"
    :request="request"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title
          class="body-2 font-weight-regular"
          style="white-space: initial;"
          v-text="item.name"
        />
      </v-list-item-content>

      <v-list-item-icon>
        <v-list-item-title
          class="font-weight-regular grey--text text--lighten-1"
          v-text="item.code"
        />
      </v-list-item-icon>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { AteRegionsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


const MODELS = [
  'User',
]

export default {
  name: 'BAutocompleteRegion',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    model: {
      type: String,
      required: true,
      validator: (prop) => MODELS.includes(prop),
    },
  },
  created() {
    const api = new AteRegionsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.getAll({ ...params, model }, ...args)
    },
  },
}
</script>
